import React, { forwardRef, useMemo } from "react";
import CloseIcon from "@mui/icons-material/Close";

const QUESTION_COUNT = 20;

/**
 * Per-question breakdown for one assignment.
 *
 * Was twenty disabled MUI TextFields. Disabled inputs are the wrong element for
 * read-only data: they drop out of the tab order, render at reduced contrast
 * that fails AA, and imply a form that could be submitted. This is a plain
 * definition grid instead, and the close control is a real <button>.
 *
 * forwardRef because MUI's Modal passes a ref to its child.
 */
const ScoreModal = forwardRef(({ close, scores }, ref) => {
    const questions = useMemo(
        () =>
            Array.from({ length: QUESTION_COUNT }, (_, index) => {
                const number = index + 1;
                return { number, score: scores?.[`q${number}_score`] };
            }),
        [scores]
    );

    const answered = questions.filter(
        (item) => item.score !== null && item.score !== undefined && item.score !== ""
    );

    return (
        <div
            ref={ref}
            role="dialog"
            aria-modal="true"
            aria-labelledby="score-modal-title"
            tabIndex={-1}
            className="relative m-lg flex max-h-[80vh] w-full max-w-[56rem] flex-col rounded-panel bg-surface shadow-headerCard focus:outline-none"
        >
            <div className="flex items-center justify-between gap-md border-b border-rule-subtle p-xl">
                <div>
                    <h2
                        id="score-modal-title"
                        className="text-md font-semibold text-ink"
                    >
                        ریز نمرات
                    </h2>
                    <p className="mt-2xs text-sm text-ink-subtle">
                        نمره هر سوال به تفکیک
                    </p>
                </div>
                <button
                    type="button"
                    onClick={close}
                    aria-label="بستن"
                    className="flex h-[3.2rem] w-[3.2rem] shrink-0 items-center justify-center rounded-soft text-ink-subtle transition-colors duration-150 hover:bg-surface-sunken hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none"
                >
                    <CloseIcon sx={{ fontSize: "2rem" }} />
                </button>
            </div>

            <div className="overflow-y-auto p-xl">
                {answered.length === 0 ? (
                    <p className="py-xl text-center text-base text-ink-subtle">
                        هنوز نمره‌ای برای سوال‌ها ثبت نشده.
                    </p>
                ) : (
                    <dl className="grid grid-cols-4 gap-sm max-md:grid-cols-3 max-sm:grid-cols-2">
                        {questions.map((item) => {
                            const hasScore =
                                item.score !== null &&
                                item.score !== undefined &&
                                item.score !== "";
                            return (
                                <div
                                    key={item.number}
                                    className="rounded-card border border-rule-subtle bg-surface-sunken px-md py-sm text-center"
                                >
                                    <dt className="text-xs text-ink-subtle">
                                        سوال {item.number.toLocaleString("fa-IR")}
                                    </dt>
                                    <dd
                                        className={`mt-2xs text-lg font-semibold tabular-nums ${
                                            hasScore ? "text-ink" : "text-ink-subtle"
                                        }`}
                                    >
                                        {hasScore
                                            ? Number(item.score).toLocaleString("fa-IR")
                                            : "—"}
                                    </dd>
                                </div>
                            );
                        })}
                    </dl>
                )}
            </div>
        </div>
    );
});

export default ScoreModal;
